import React, { useEffect, useState } from 'react';
import DynamicSearchBar from '@components/common/SearchBar';
import Button from '@components/common/Button';
import PlusSvgIcon from '@assets/svg_main/plus.svg';
import './vhndUhnd.css';
import { PagePermission } from '@services/usePermission';
import { useNavigate } from 'react-router-dom';
import SessionCalendarView from './sessionCalendarView';
import _ from 'lodash';
import {
  deleteSessionApi,
  getSessionDetailsByDateSessionSiteApi,
  getSessionSiteCalenderSearchdataApi,
  getSessionSiteCalenderdataApi,
} from './sessionServices';
import SessionSiteWarningModal from './viewVhndUhnd/sessionSiteWarningModal';
import dayjs from 'dayjs';
import { buttonNames } from '@constants/appConstants';
import { filter_type } from '@constants/sessionSiteConstant';
import { dateFormate } from '@constants/index';
import FormatDate from '@utils/dateFormat';

const VhndUhnd = () => {
  const navigate = useNavigate();
  const [sessionsData, setSessionsData] = useState<any>([]);
  const [sessionsFilterData, setSessionsFilterData] = useState<any>([]);
  const [sessionsViewListData, setSessionsViewListData] = useState<any>([]);
  const [sessionsDataCount, setSessionsDataCount] = useState<any>(0);
  const canCreateVhndUhnd = PagePermission(
    'GeoNG_VHNDUHND',
    'GeoNG_VHNDUHND_CrPg',
  );
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [prevSearchTerm, setPrevSearchTerm] = useState<string>('');
  const [showWarningModal, setShowWarningModal] = useState<boolean>(false);
  const [sessionStatusType, setSessionStatusType] = useState<string>('');
  const [sessionId, setSessionId] = useState<any>('');
  const [eventsOnDate, setEventsOnDate] = useState<any>([]);
  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  const [localFilterType, setLocalFilterType] = useState<string>(filter_type.all);
  const handleCreatepage = () => {
    navigate(`/VHND/create`);
  };

  const trigerCalenderDataFetch = () => {
    if (searchTerm.trim().length === 0) {
      initialFetch(dayjs());
    }
    if(prevSearchTerm && prevSearchTerm === searchTerm.trim()){
      return;
    }
    setPrevSearchTerm(searchTerm.trim());
    if (searchTerm.trim().length >= 3) {
      filterFetch(searchTerm.trim());
    }
  };

  useEffect(() => {
    trigerCalenderDataFetch();
  }, [searchTerm]);

  const getMonthDates = (date: any) => {
    const startOfMonth = FormatDate(dayjs(date).startOf('month'))?.toString();
    const endOfMonth = FormatDate(dayjs(date).endOf('month'))?.toString();
    return { startDate: startOfMonth, endDate: endOfMonth };
  };

  const initialFetch = async (date: any) => {
    const payLoad = {
      startDate: getMonthDates(date).startDate,
      endDate: getMonthDates(date).endDate
    };
    const response = await getSessionSiteCalenderdataApi(payLoad);
    if (response) {
      setSessionsDataCount(response?.data.length);
      prepareCalendarData(response?.data);
      prepareGridViewData(response?.data);
      setSessionsFilterData(response?.data);
    }
  };

  const filterFetch = async (searchTerm: any) => {
    const res: any = await getSessionSiteCalenderSearchdataApi(searchTerm);
    if (res) {
      setSessionsDataCount(res?.data.length);
      prepareCalendarData(res.data);
      prepareGridViewData(res.data);
      setSessionsFilterData(res?.data);
    }
  };

  const prepareCalendarData = (sessionResData: any) => {
    const serviceDates = sessionResData?.map((el: any) =>
      el?.session_planned_date?.toString(),
    );
    let finalData = [...new Set(serviceDates)]
      .map((date) => {
        const finaldata: any = [];
        const types: any = [];
        const typesArr = ['vhnd', 'uhnd', 'outreach'];

        typesArr?.forEach((type) => {
          if (
            sessionResData?.find(
              (el1: any) =>
                el1?.session_planned_date?.toString() == date &&
                el1?.session_type_code == type,
            )
          ) {
            types.push(type);
          }
        });

        finaldata.push({
          start: sessionResData?.find(
            (el1: any) => el1?.session_planned_date?.toString() == date,
          )?.session_planned_date,
          end: sessionResData?.find(
            (el1: any) => el1?.session_planned_date?.toString() == date,
          )?.session_planned_date,
          types: types,
        });
        return finaldata;
      })
      .flat();
    finalData = finalData?.map((el: any, i: number) => {
      el.id = i;
      return el;
    });
    setSessionsData(finalData);
  };

  const prepareGridViewData = (sessionResData: any) => {
    const finalData = sessionResData?.map((el: any, i: number) => {
      return {
        id: i,
        start: el?.session_planned_date,
        end: el?.session_planned_date,
        type: el?.session_type_code,
        title: el?.session_name,
        session_id: el?.session_id,
        session_status_code: el?.session_status_code,
        session_status_id: el?.session_status_id,
        session_status_name: el?.session_status_name,
      };
    });
    setSessionsViewListData(finalData);
  };

  const handleSearchChange = _.debounce((value: string) => {
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;
    if(alphanumericRegex.test(value)){
        setSearchTerm(value);
    }
  }, 1000);

  const getSessionDetailsByDateSessionSite = async (
    date: any,
    localFilterType: any
  ) => {
    setSelectedDate(date);
    const newDate = dayjs(date).format(dateFormate.yyyy_mm_dd);
    const response = await getSessionDetailsByDateSessionSiteApi(newDate);
    if (response) {
      const sessionResData = localFilterType !== filter_type.all ? response?.data.filter((ele: any) => ele.session_type_code == localFilterType) : response?.data;
      setEventsOnDate(sessionResData);
    }
  };

  const handleDeleteSessionWarningClose = () => {
    setSessionStatusType('');
    setShowWarningModal(false);
    setSessionId('');
  };

  const handleStatusSubmit = async () => {
    const payLoad = {
      sessionId: sessionId,
      remarks: ''
    };
    const response = await deleteSessionApi(payLoad);
    if (response) {
      handleDeleteSessionWarningClose();
      trigerCalenderDataFetch();
      getSessionDetailsByDateSessionSite(selectedDate, localFilterType);
    }
  };

  const sessionFilterHandler = async (type: any) => {
    setLocalFilterType(type);
    let filteredSessions = sessionsFilterData;
    if (type !== filter_type.all) {
      filteredSessions = sessionsFilterData.filter((v: any) => v.session_type_code === type);
    }
    setSessionsDataCount(filteredSessions.length);
    getSessionDetailsByDateSessionSite(selectedDate, type);
  }; 

  const handleCalenderActionButtons = async (dateFromCalendar: any) => {
    setEventsOnDate('');
    setLocalFilterType(filter_type.all)
    setSelectedDate(new Date());
    const today = new Date();

    if (today.getDate() == dateFromCalendar.getDate() && today.getMonth() == dateFromCalendar.getMonth() && today.getFullYear() == dateFromCalendar.getFullYear()) {
      await initialFetch(dateFromCalendar);
    } else {
      await initialFetch(dateFromCalendar);
    }
  };

  return (
    <>
      <div className="vhnd-management-details">
        <div className="search-add-events">
          <DynamicSearchBar
            onChange={handleSearchChange}
            placeHolder={buttonNames.search_name}
            disabled={false}
            className="event-search"
            iconNeeded={true}
            value={searchTerm}
          />
          {canCreateVhndUhnd && (
            <Button
              onClick={handleCreatepage}
              disabled={false}
              id="add-newSession"
              buttonName={buttonNames.new_session}
              colorType={'primary'}
              icon={<PlusSvgIcon />}
              iconPosition={'left'}
            />
          )}
        </div>
        <SessionCalendarView
          sessionsData={sessionsData}
          sessionsViewListData={sessionsViewListData}
          sessionsDataCount={sessionsDataCount}
          sessionFilterHandler={sessionFilterHandler}
          setShowWarningModal={setShowWarningModal}
          setSessionStatusType={setSessionStatusType}
          setSessionId={setSessionId}
          eventsOnDate={eventsOnDate}
          getSessionDetailsByDateSessionSite={(date: any) => getSessionDetailsByDateSessionSite(date, localFilterType)}
          handleCalenderActionButtons={(date: any) => handleCalenderActionButtons(date)}
          selectedDate={selectedDate}
        />
      </div>
      <SessionSiteWarningModal
        handleCloseModal={() => handleDeleteSessionWarningClose()}
        sessionStatusType={sessionStatusType}
        showWarningModal={showWarningModal}
        handleWarningModalBackButton={() => handleDeleteSessionWarningClose()}
        handleFinalProceed={() => handleStatusSubmit()}
      />
      </>

  );
};
export default VhndUhnd;
